/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Bulk user item
 * @export
 * @interface BulkUserItem
 */
export interface BulkUserItem {
    /**
     * User email address
     * @type {string}
     * @memberof BulkUserItem
     */
    email: string;
    /**
     * User first name
     * @type {string}
     * @memberof BulkUserItem
     */
    firstName?: string;
    /**
     * User last name
     * @type {string}
     * @memberof BulkUserItem
     */
    lastName?: string;
    /**
     * Role to assign to this user (overrides defaultRole if specified)
     * @type {string}
     * @memberof BulkUserItem
     */
    role?: string;
}

/**
 * Check if a given object implements the BulkUserItem interface.
 */
export function instanceOfBulkUserItem(value: object): value is BulkUserItem {
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function BulkUserItemFromJSON(json: any): BulkUserItem {
    return BulkUserItemFromJSONTyped(json, false);
}

export function BulkUserItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkUserItem {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'role': json['role'] == null ? undefined : json['role'],
    };
}

export function BulkUserItemToJSON(json: any): BulkUserItem {
    return BulkUserItemToJSONTyped(json, false);
}

export function BulkUserItemToJSONTyped(value?: BulkUserItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'role': value['role'],
    };
}

